export function mapFeatureTenant(TenantData) {

    const featureFlags = [
        {
            accessKey: 'featureAccessVehiclePhotoLogsHeraAi',
            enabledKey: 'featureEnabledVehiclePhotoLogsHeraAi',
            accessName: 'Vehicle Management: Vehicle Photo Logs Hera AI',
            enabledName: 'Vehicle Management: Vehicle Photo Logs Hera AI'
        },
        {
            accessKey: 'featureAccessInventoryManagement',
            enabledKey: 'featureEnabledInventoryManagement',
            accessName: 'Inventory Management',
            enabledName: 'Inventory Management'
        },
        {
            accessKey: 'featureAccessRosterChecklist',
            enabledKey: 'featureEnabledRosterChecklist',
            accessName: 'Roster Checklist',
            enabledName: 'Roster Checklist'
        },
        {
            accessKey: 'featureAccessWirelessSupportSync',
            enabledKey: 'featureEnabledWirelessSupportSync',
            accessName: 'Wireless Support Sync',
            enabledName: 'Wireless Support Sync'
        },
        {
            accessKey: 'featureAccessCustomEmailSending',
            enabledKey: 'featureEnabledCustomEmailSending',
            accessName: 'Custom Email Sending',
            enabledName: 'Custom Email Sending'
        },
        {
            accessKey: 'featureAccessAssociateApp',
            enabledKey: 'featureEnabledAssociateApp',
            accessName: 'Associate App',
            enabledName: 'Associate App'
        },
        {
            accessKey: 'featureAccessHeraMessenger2',
            enabledKey: 'featureEnabledHeraMessenger2',
            accessName: 'Hera Messenger 2',
            enabledName: 'Hera Messenger 2',
        },
        {
            accessKey: 'featureAccessPhoneAutomation',
            enabledKey: 'featureEnabledPhoneAutomation',
            accessName: 'Phone Automation',
            enabledName: 'Phone Automation',
        },
        {
            accessKey: 'featureAccessFilesManagement',
            enabledKey: 'featureEnabledFilesManagement',
            accessName: 'File Management',
            enabledName: 'File Management',
        },
        {
            accessKey: 'featureAccessFilesSignatureRequest',
            enabledKey: 'featureEnabledFilesSignatureRequest',
            accessName: 'Signature Requests',
            enabledName: 'Signature Requests',
        },
        {
            accessKey: 'featureAccessAmazonChromePlugin',
            enabledKey: 'featureEnabledAmazonChromePlugin',
            accessName: 'Hera Amazon Chrome Plugin',
            enabledName: 'Hera Amazon Chrome Plugin',
        },
        {
            accessKey: 'featureAccessAIChat',
            enabledKey: 'featureEnabledAIChat',
            accessName: 'Hera AI Chat',
            enabledName: 'Hera AI Chat',
        },
        {
            accessKey: 'featureAccessPayrollProvider',
            enabledKey: 'featureEnabledPayrollProvider',
            accessName: 'Payroll Provider',
            enabledName: 'Payroll Provider',
        },
        {
            accessKey: 'featureAccessHierarchicalPermissions',
            enabledKey: 'featureEnabledHierarchicalPermissions',
            accessName: 'Hierarchical Permissions',
            enabledName: 'Hierarchical Permissions',
        },
        {
            accessKey: 'featureAccessSchedulingAndRostering',
            enabledKey: 'featureEnabledSchedulingAndRostering',
            accessName: 'Scheduling & Rostering',
            enabledName: 'Scheduling & Rostering',
        },
    ];

    featureFlags.forEach(({ accessKey, enabledKey, accessName }) => {
        TenantData[accessKey] = TenantData.featureAccess.includes(accessName);
        TenantData[enabledKey] = TenantData.featureEnabled.includes(accessName);
    });

    return TenantData;
}